import { NextRouter } from 'next/router';

type RemoveParams = {
  key: string;
  path: string;
  router: NextRouter;
};

export const removeQueryParam = ({ key, path, router }: RemoveParams) => {
  if (router.asPath.includes(path)) {
    const queryParams = router.query;
    delete queryParams[key];
    router.replace(
      {
        pathname: path,
        query: queryParams,
      },
      undefined,
      { shallow: true }
    );
  }
};
